// @mui
import Link from '@mui/material/Link';
// routes
import { paths } from 'src/routes/paths';

export const SECURITY_PAGE_TABS = [
  {
    icon: 'solar:lock-password-bold',
    title: 'Our Dedication to Your Security',
    text: (
      <ul>
        <li>
          <strong>Securing Your Information:</strong> We implement robust safeguards to ensure your personal data is shielded from unauthorized access and potential breaches.
        </li>
        <li>
          <strong>Transparent Processes:</strong> Our security practices are clearly explained so you always understand how your data is being protected.
        </li>
        <li>
          <strong>Industry Standard Protocols:</strong> Our team continuously updates our security measures in line with proven standards to counter emerging threats.
        </li>
        <li>
          <strong>Dedicated Assistance:</strong> If you have any questions or concerns, our experienced support staff is available to provide prompt assistance.
        </li>
      </ul>
    )
  },
  {
    icon: 'solar:shield-bold',
    title: 'Enhanced Data Protection Techniques',
    text: (
      <ul>
        <li>
          <strong>File-Level Encryption:</strong> Sensitive documents are encrypted to ensure that they remain private and are accessed solely by those with proper rights.
        </li>
      </ul>
    )
  },
  {
    icon: 'solar:shield-keyhole-bold',
    title: 'Controlled Access Management',
    text: (
      <ul>
        <li>
          <strong>Strong Password Protocols:</strong> We enforce the use of complex passwords to enhance account security and minimize risks.
        </li>
        <li>
          <strong>Two-Factor Authentication:</strong> By requiring an extra form of verification during login, we add an additional layer of protection against unauthorized access.
        </li>
        <li>
          <strong>Unified Sign-On:</strong> Our Single Sign-On (SSO) option streamlines the login process while upholding rigorous security standards.
        </li>
        <li>
          <strong>Role-Based Access:</strong> We assign access rights based on roles, ensuring individuals only gain access to information essential for their responsibilities.
        </li>
      </ul>
    )
  },
  {
    icon: 'ic:baseline-privacy-tip',
    title: 'Privacy and Regulatory Adherence',
    text: (
      <ul>
        <li>
          <strong>Respect for Your Privacy:</strong> We adhere to data protection regulations such as GDPR, ensuring your personal information is handled with the utmost care.{' '}
          <Link href={paths.legal.privacyPolicy} color="primary" underline="hover">
            Read our full privacy policy
          </Link>.
        </li>
        <li>
          <strong>Strict Legal Compliance:</strong> Our practices meet international data protection laws and standards to provide you with consistent security.
        </li>
        <li>
          <strong>Certified Security Standards:</strong> With certifications like ISO 27001 and SOC 2 under our belt, we validate our commitment to top-tier security measures.
        </li>
        <li>
          <strong>Data Residency Assurance:</strong> Your data is maintained in secure, compliant data centers that meet both local and global regulatory requirements.
        </li>
      </ul>
    )
  },
  {
    icon: 'material-symbols:monitoring',
    title: 'Round-The-Clock Surveillance and Rapid Response',
    text: (
      <ul>
        <li>
          <strong>Continuous Monitoring:</strong> Our systems are under constant surveillance to identify and neutralize potential threats as quickly as possible.
        </li>
        <li>
          <strong>Intelligent Threat Analysis:</strong> Leveraging advanced analytics, we detect unusual patterns and promptly initiate targeted investigations.
        </li>
        <li>
          <strong>Swift Incident Mitigation:</strong> A robust incident response plan enables us to rapidly address any security breach or anomaly.
        </li>
      </ul>
    )
  },
  {
    icon: 'healthicons:test-tubes-24px',
    title: 'Forward-Thinking Security Practices',
    text: (
      <ul>
        <li>
          <strong>Regular Security Evaluations:</strong> We routinely conduct audits and penetration tests to discover and remedy vulnerabilities before they can be exploited.
        </li>
        <li>
          <strong>Collaborative Vulnerability Disclosure:</strong> By inviting insights from external security experts, we foster a collaborative environment for continuous improvement.
        </li>
        <li>
          <strong>State-of-the-Art Tools:</strong> Our security arsenal includes trusted technologies like Snyk and AWS GuardDuty to fortify our defenses.
        </li>
      </ul>
    )
  },
  {
    icon: 'fa6-solid:handshake-angle',
    title: 'Secured Partnerships and Infrastructure',
    text: (
      <ul>
        <li>
          <strong>Reliable Provider Collaborations:</strong> We team up with top-tier cloud and service providers to ensure our infrastructure is resilient and secure.
        </li>
        <li>
          <strong>Thorough Vendor Assessments:</strong> All third-party vendors are rigorously evaluated to ensure they maintain security practices consistent with our high standards.
        </li>
        <li>
          <strong>Effective Data Isolation:</strong> We implement strict segmentation in multi-tenant environments, ensuring complete data isolation between users.
        </li>
      </ul>
    )
  },
  {
    icon: 'mdi:refresh',
    title: 'Resilience and Continuity Planning',
    text: (
      <ul>
        <li>
          <strong>Frequent Data Backups:</strong> We perform regular backups and test our disaster recovery protocols to ensure rapid restoration of your data.
        </li>
        <li>
          <strong>High-Availability Architecture:</strong> Our infrastructure is engineered to remain operational under adverse conditions, minimizing service disruptions.
        </li>
      </ul>
    )
  },
  {
    icon: 'bxs:report',
    title: 'Security Issue Reporting',
    text: (
      <ul>
        <li>
          <strong>Promoting a Vigilant Community:</strong> We actively encourage reporting of any security concerns to continuously enhance our protective measures.
        </li>
        <li>
          <strong>Prompt Communication:</strong> If you notice a potential vulnerability, please reach out to us at{' '}
          <Link href="mailto:support@simpletranslate.io" color="primary" underline="hover">
            support@simpletranslate.io
          </Link>{' '}
          with detailed information for a swift response.
        </li>
      </ul>
    )
  },
  {
    icon: 'fluent:brain-circuit-20-filled',
    title: 'Ongoing Security Education and Training',
    text: (
      <ul>
        <li>
          <strong>Consistent Training Programs:</strong> Our team participates in ongoing training sessions to stay abreast of the latest security trends and best practices.
        </li>
        <li>
          <strong>Realistic Simulation Drills:</strong> We conduct phishing and security simulations regularly to ensure our team is always prepared for emerging threats.
        </li>
        <li>
          <strong>Embedding a Security-First Culture:</strong> By integrating security into every aspect of our operations, we maintain vigilant and proactive practices throughout the organization.
        </li>
      </ul>
    )
  },
];
